const sliders = document.querySelectorAll( '.big-slider' );

sliders.forEach( slider => {
    jQuery( slider.querySelector( '.big-slider__slider' ) ).slick( {
        speed: 600,
        slidesToShow: 1,
        cssEase: 'ease',
        arrows: true,
        prevArrow: slider.querySelector( '.big-slider-prev' ),
        nextArrow: slider.querySelector( '.big-slider-next' ),
    } );
} );
